import { useMemo } from 'react';
import { useLocalizedField } from '@/common/hooks/index';
import { useGeneralMetaDataQuery } from '@/entities/meta-data';

const useSectionsQuestions = (questions) => {
  const { data: metaData = {} } = useGeneralMetaDataQuery();
  const { general } = metaData;
  const getLocalizedField = useLocalizedField();
  const subsectionsMapper = getLocalizedField(general, 'subsectionsMapper');

  const questionsWithSections = useMemo(() => {
    if (!questions) return [];
    return questions.reduce((acc, { questions, subsection }) => {
      questions[0].subsection = subsectionsMapper[subsection] || subsection;

      acc = acc.concat(questions);
      return acc;
    }, []);
  }, [questions, subsectionsMapper]);

  return useMemo(
    () => ({ questions: questionsWithSections }),
    [questionsWithSections]
  );
};

export default useSectionsQuestions;
